<ion-app>
  <ion-split-pane when="sm" id="main-content" [class.has-footer]="hasCompletedSetup">
    <ion-menu *ngIf="hasCompletedSetup" contentId="main-content" side="start" type="overlay">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ 'MENU.TITLE' | translate }}</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="menu-content">
        <div class="menu-shell">
          <ion-list class="menu-list">
            <ion-item id="home-page-button" routerLink="/playlists">
              <ion-icon name="home" slot="start"></ion-icon>
              <ion-label>{{ 'MENU.HOME' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/leaderboard">
              <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
              <ion-label>{{ 'MENU.LEADERBOARD' | translate }}</ion-label>
            </ion-item>
            <ion-item routerLink="/sync-learning">
              <ion-icon name="headset-outline" slot="start"></ion-icon>
              <ion-label>Sync Learning</ion-label>
            </ion-item>
            <ion-item *ngIf="user" routerLink="/settings">
              <ion-icon name="settings" slot="start"></ion-icon>
              <ion-label>{{ 'MENU.SETTINGS' | translate }}</ion-label>
            </ion-item>
            <ion-item *ngIf="!user" routerLink="/login" class="login-item">
              <ion-icon name="person-outline" slot="start"></ion-icon>
              <ion-label>{{ 'LOGIN.LOGIN_BUTTON' | translate }}</ion-label>
            </ion-item>
          </ion-list>

          <ion-item button lines="none" class="desktop-theme-toggle" (click)="toggleTheme()" aria-label="Toggle theme">
            <ion-icon [name]="darkMode ? 'moon' : 'sunny'" slot="start"></ion-icon>
            <ion-label>{{ darkMode ? ('SETUP.DARK_MODE' | translate) : ('SETUP.LIGHT_MODE' | translate) }}</ion-label>
          </ion-item>

          <ion-item button lines="none" href="https://discord.gg/Pf8p25W7ME" target="_blank" rel="noopener noreferrer" class="discord-link">
            <ion-icon name="logo-discord" slot="start"></ion-icon>
            <ion-label>Discord</ion-label>
          </ion-item>
        </div>
      </ion-content>
    </ion-menu>

    <ion-content>
      <ion-router-outlet></ion-router-outlet>
    </ion-content>
  </ion-split-pane>

  <ion-footer *ngIf="hasCompletedSetup" class="mobile-footer">
    <ion-buttons id="footer-toolbar">
      <ion-button id="home-page-button" routerLink="/playlists"><ion-icon name="home"></ion-icon></ion-button>
      <ion-button routerLink="/leaderboard"><ion-icon name="bar-chart-outline"></ion-icon></ion-button>
      <ion-button routerLink="/sync-learning"><ion-icon name="headset-outline"></ion-icon></ion-button>
      <ion-button *ngIf="user" routerLink="/settings"><ion-icon name="settings"></ion-icon></ion-button>
      <ion-button *ngIf="!user" routerLink="/login" class="login-btn">
        <div class="login-btn-inner">
          <ion-icon name="person-outline"></ion-icon>
          <span class="login-label">{{ 'LOGIN.LOGIN_BUTTON' | translate }}</span>
        </div>
      </ion-button>
      <ion-button href="https://discord.gg/Pf8p25W7ME" target="_blank" rel="noopener noreferrer"><ion-icon name="logo-discord"></ion-icon></ion-button>
    </ion-buttons>
  </ion-footer>
</ion-app>
